import { render, staticRenderFns } from "./OrdineComponentiArrivi.vue?vue&type=template&id=653160bc&scoped=true"
import script from "./OrdineComponentiArrivi.vue?vue&type=script&lang=js"
export * from "./OrdineComponentiArrivi.vue?vue&type=script&lang=js"
import style0 from "./OrdineComponentiArrivi.vue?vue&type=style&index=0&id=653160bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653160bc",
  null
  
)

export default component.exports